import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../state/app.state";
import {CommonService} from "../services/common.service";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {profile} from "../core/shared.selectors";
import {roleUrlMap} from "../constants/common.constants";
import {FetchProfileRequest} from "../core/shared.actions";

@Injectable({
  providedIn: 'root'
})
export class RoleGuard {
  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private commonService: CommonService,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    let isAllowed = false;
    let role;

    this.store.select(profile).subscribe((profile) => {
      if (profile?.id) {
        role = profile.role;
        if (role && typeof role === 'object') {
          role = role.key;
        }
        if (typeof role !== 'number') {
          this.commonService.logout();
          return;
        }

        if (roleUrlMap[role] === route.routeConfig.path) {
          isAllowed = true;
        }
      } else {
        this.store.dispatch(FetchProfileRequest());
      }
    }).unsubscribe();

    if (isAllowed) {
      return true;
    }

    if (role) {
      this.router.navigate([roleUrlMap[role]]);
    }
    return false;
  }
}
